
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"12","viewBox":"0 0 12 12"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.637 5.759a1.271 1.271 0 00.294-1.3 1.255 1.255 0 00-1.015-.859L8.34 3.2a.084.084 0 01-.054-.048L7.157.752A1.268 1.268 0 004.845.734l-1.129 2.4a.1.1 0 01-.06.048L1.088 3.6a1.273 1.273 0 00-1.021.858 1.289 1.289 0 00.3 1.3l1.9 1.95a.1.1 0 010 .078l-.449 2.724a1.273 1.273 0 001.88 1.326l2.24-1.242a.078.078 0 01.072 0l2.24 1.242a1.279 1.279 0 001.88-1.326L9.715 7.8a.072.072 0 010-.072z","fill":"#fed029"}})])
          )
        }
      }
    